var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M788 485L788 513",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 788.5,
    cy: 480.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M783.987 480.19C783.987 476.283 787.288 473.117 791.358 473.117C791.943 473.117 792.511 473.184 793.056 473.308C791.742 472.48 790.187 472 788.519 472C783.814 472 780 475.806 780 480.5C780 485.194 783.814 489 788.519 489C790.814 489 792.895 488.093 794.427 486.62C793.492 487.032 792.454 487.263 791.358 487.263C787.288 487.263 783.987 484.096 783.987 480.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M797.402 479.6L797.37 477.146L795.535 478.719L793.304 478.056L794.112 480.337L792.765 482.381L795.1 482.218L796.499 484.144L797.133 481.763L799.345 480.909L797.402 479.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch2);
export default __webpack_public_path__ + "static/media/church_2.657341a880fa0ab360525e194d5d4d42.svg";
export { ForwardRef as ReactComponent };